import { postLikeOutfit } from './postLikeOutfit';
import { removeLikeOutfit } from './removeLikeOutfit';
import { postBookmarkOutfit } from './postBookmarkOutfit';
import { removeBookmarkOutfit } from './removeBookmarkOutfit';

export const outfitService = {
  postLike: postLikeOutfit,
  removeLike: removeLikeOutfit,
  postBookmark: postBookmarkOutfit,
  removeBookmark: removeBookmarkOutfit,
};
